import React, { useEffect, useState } from 'react';
import {
  DeleteButton,
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  PasswordInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  AutocompleteInput,
  SaveButton,
  Toolbar,
  useTranslate,
  FormDataConsumer,
  useDataProvider,
} from 'react-admin';

import { PERMISSIONS } from '../../constants';
import Permission from '../../components/Permission';
import { filterToQuery } from '../../utils';


export default props => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const [chainOpts, setChainOpts] = useState([]);

  useEffect(() => {
    dataProvider.getList('chains', {
      filter: {},
      sort: { field: 'name', order: 'ASC' },
      pagination: { page: 1, perPage: 1000 }
    })
      .then(({ data }) => {
        setChainOpts(data);
      });
  }, []);

  const ExternalPartnerToolbar = () => (
    <Toolbar sx={{ gap: 1 }}>
      <SaveButton />
      <DeleteButton mutationMode="pessimistic" redirect="/external-partners" confirmTitle="Excluir parceiro externo" sx={{ marginLeft: 'auto' }} />
    </Toolbar>
  );

  return (
    <Permission permission={PERMISSIONS.ADMIN}>
      <Edit {...props} title="Editar Parceiro Externo">
        <TabbedForm toolbar={<ExternalPartnerToolbar />}>
          <FormTab label="Dados Gerais">
            <TextInput source="name" label="Nome" validate={required()} InputProps={{ autoComplete: 'off' }} />
            <TextInput source="login" label="Login" validate={required()} InputProps={{ autoComplete: 'off' }} />
            <PasswordInput source="password" label="Senha (deixe em branco para não alterar)" helperText="Preencha apenas se quiser alterar a senha" InputProps={{ autoComplete: 'new-password' }} />
            <TextInput source="token" label="Token (Deprecated)" helperText="Mantido por compatibilidade" InputProps={{ autoComplete: 'off' }} />
          </FormTab>
          <FormTab label="Redes">
            <ArrayInput source="externalPartnerChains" label="">
              <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                  {({ formData, scopedFormData }) => {
                    const selectedChainIds = formData.externalPartnerChains
                      ? formData.externalPartnerChains.filter((c) => c).map(c => c.chainId)
                      : [];

                    const availableChains = chainOpts.filter(
                      ({ id }) => !selectedChainIds.includes(id) ||
                        (scopedFormData ? scopedFormData.chainId === id : false)
                    );

                    return (
                      <AutocompleteInput
                        source="chainId"
                        choices={availableChains}
                        filterToQuery={filterToQuery}
                        label="Rede"
                        optionText="name"
                        validate={required()}
                        sx={{ minWidth: 220 }}
                        noOptionsText={translate('ra.input.autocomplete.no_options_text')}
                      />
                    );
                  }}
                </FormDataConsumer>
              </SimpleFormIterator>
            </ArrayInput>
          </FormTab>
        </TabbedForm>
      </Edit>
    </Permission>
  )
};
